import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=5879e299&scoped=true"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"
import style0 from "./Quiz.vue?vue&type=style&index=0&id=5879e299&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5879e299",
  null
  
)

export default component.exports